var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645",
    transform: "translate(-138.917 -190.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.66,2.34a8,8,0,1,0,0,11.319A8.011,8.011,0,0,0,13.66,2.34Zm-.876,10.443a6.763,6.763,0,1,1,0-9.566A6.769,6.769,0,0,1,12.784,12.783Z",
    transform: "translate(138.917 190.04)",
    fill: "#445064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-car-battery",
    "data-name": "Icon awesome-car-battery",
    d: "M8.854,5.634h-.59V4.784a.289.289,0,0,0-.3-.284H6.2a.289.289,0,0,0-.3.284v.851H3.542V4.784a.289.289,0,0,0-.3-.284H1.476a.289.289,0,0,0-.3.284v.851H.59A.579.579,0,0,0,0,6.2v4.538a.579.579,0,0,0,.59.567H8.854a.579.579,0,0,0,.59-.567V6.2A.579.579,0,0,0,8.854,5.634ZM3.542,8.045a.145.145,0,0,1-.148.142H1.328a.145.145,0,0,1-.148-.142V7.761a.145.145,0,0,1,.148-.142H3.394a.145.145,0,0,1,.148.142Zm4.722,0a.145.145,0,0,1-.148.142H7.378V8.9a.145.145,0,0,1-.148.142h-.3A.145.145,0,0,1,6.788,8.9V8.187H6.05A.145.145,0,0,1,5.9,8.045V7.761A.145.145,0,0,1,6.05,7.62h.738V6.911a.145.145,0,0,1,.148-.142h.3a.145.145,0,0,1,.148.142V7.62h.738a.145.145,0,0,1,.148.142Z",
    transform: "translate(142.194 190.137)",
    fill: "#445064"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.bf5539b0.svg";
export { ForwardRef as ReactComponent };